/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  AllCategoriesResponse,
  CategoryDetailsParams,
  CategoryResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useCategoriesHook = () => {
        const categories = useCustomInstance<AllCategoriesResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return categories(
          {url: `/AvailabilityLists/Index`, method: 'GET', signal
    },
          );
        }, [categories])
      }
    

export const getCategoriesQueryKey = () => {
    return [`/AvailabilityLists/Index`] as const;
    }

    
export const useCategoriesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCategoriesQueryKey();

  const categories =  useCategoriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>> = ({ signal }) => categories(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CategoriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>>
export type CategoriesQueryError = unknown


export function useCategories<TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategories<TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategories<TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCategories<TData = Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useCategoryDetailsHook = () => {
        const categoryDetails = useCustomInstance<CategoryResponse>();

        return useCallback((
    params?: CategoryDetailsParams,
 signal?: AbortSignal
) => {
        return categoryDetails(
          {url: `/AvailabilityLists/Details`, method: 'GET',
        params, signal
    },
          );
        }, [categoryDetails])
      }
    

export const getCategoryDetailsQueryKey = (params?: CategoryDetailsParams,) => {
    return [`/AvailabilityLists/Details`, ...(params ? [params]: [])] as const;
    }

    
export const useCategoryDetailsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError = unknown>(params?: CategoryDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCategoryDetailsQueryKey(params);

  const categoryDetails =  useCategoryDetailsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>> = ({ signal }) => categoryDetails(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CategoryDetailsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>>
export type CategoryDetailsQueryError = unknown


export function useCategoryDetails<TData = Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError = unknown>(
 params: undefined |  CategoryDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategoryDetails<TData = Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError = unknown>(
 params?: CategoryDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategoryDetails<TData = Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError = unknown>(
 params?: CategoryDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCategoryDetails<TData = Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError = unknown>(
 params?: CategoryDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCategoryDetailsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCategoryDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



